<div class="title">
    <span>{{ 'realtime:usergroups_setPauseTitle' | i18next }}</span>
        <i id="close-icon-set-pause-dialog" class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false" (click)="closeDialog()"></i>
</div>

<div class="dialog-content">
  <p>{{ 'realtime:usergroups_setPauseText' | i18next }}</p>

    <ng-select id="pause-reason-dropdown-set-pause-dialog" appendTo="#ddl-panel-wrapper"  [items]="pauseReasons" [(ngModel)]="selectedPauseId"  [bindLabel]="'description'" [bindValue]="'id'" [clearable]="false" [searchable]="false">

    </ng-select>
</div>

<mat-dialog-actions>
    <app-basic-button id="close-btn-set-pause-dialog" type="secondary" size="large" (click)="closeDialog()"> {{ 'translation:Close' | i18next }}</app-basic-button>
    <app-basic-button id="confirm-btn-set-pause-dialog" type="primary" size="large" (click)="closeDialogWithResult(selectedPauseId)" [disabled]="!selectedPauseId">
      {{ 'realtime:usergroups_setPauseConfirm' | i18next }}
    </app-basic-button>

</mat-dialog-actions>
